import { Link } from "react-router-dom";
import { useTranslation } from "@refinedev/core";
import { IPickupSportParticipantDetail } from "interfaces";
import { CollapsibleSection } from "components/collapsibleSection";

export const InformationSection = ({
  participantDetailData,
}: {
  participantDetailData: IPickupSportParticipantDetail;
}) => {
  const { translate } = useTranslation();

  return (
    <CollapsibleSection label={translate("information")} defaultOpen={true}>
      <div
        className="grid gap-x-4 gap-y-6 px-4 py-4 text-sm sm:px-6 grid-cols-12 lg:gap-x-6"
        style={{ wordBreak: "break-word" }}
      >
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-1">
          <div className="col-span-2">
            <p className="font-medium">{translate("checkin.participant-id")}</p>
          </div>
          <div className="col-span-4">
            <p>{participantDetailData?.participant.participant_id}</p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-3">
          <div className="col-span-2">
            <p className="font-medium">{translate("order-code")}</p>
          </div>
          <div className="col-span-4">
            <Link
              to={`/orders/${participantDetailData?.participant.order_code}`}
              className="w-fit font-medium text-brand-500 hover:underline"
            >
              {participantDetailData?.participant.order_code}
            </Link>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-5">
          <div className="col-span-2">
            <p className="font-medium">{translate("checkin.bib-number")}</p>
          </div>
          <div className="col-span-4">
            <p>{participantDetailData?.participant.bib}</p>
          </div>
        </div>

        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-7">
          <div className="col-span-2">
            <p className="font-medium">{translate("age")}</p>
          </div>
          <div className="col-span-4">
            <p>{participantDetailData?.participant.age}</p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-2">
          <div className="col-span-2">
            <p className="font-medium">{translate("checkin.event-name")}</p>
          </div>
          <div className="col-span-4">
            <p>{participantDetailData?.participant.event_name}</p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-4">
          <div className="col-span-2">
            <p className="font-medium">{translate("ticket-name")}</p>
          </div>
          <div className="col-span-4">
            <p>{participantDetailData?.participant.ticket_name_en}</p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-6">
          <div className="col-span-2">
            <p className="font-medium">{translate("full-name")}</p>
          </div>
          <div className="col-span-4">
            <p>{participantDetailData?.participant.full_name}</p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-8">
          <div className="col-span-2">
            <p className="font-medium">{translate("checkin.category")}</p>
          </div>
          <div className="col-span-4">
            <p>{participantDetailData?.participant.category}</p>
          </div>
        </div>
      </div>
    </CollapsibleSection>
  );
};
